import {useMemo} from 'react';
import {getRoleTypeName} from '../../../utils';

function UserInfo() {
  const stringifyUser = localStorage.getItem('user');
  const user =
    stringifyUser && stringifyUser !== 'undefined'
      ? JSON.parse(stringifyUser)
      : null;
  const userChar = useMemo(() => {
    const first = (user?.firstName ?? '').trim();
    const last = (user?.lastName ?? '').trim();

    // Split first name to support "Mary Jane" -> MJ if no last name provided
    const firstParts = first.split(/\s+/).filter(Boolean);

    const pickFirstGrapheme = (s: string) => (s ? Array.from(s)[0] : '');

    const a = pickFirstGrapheme(firstParts[0] ?? '');
    const b = pickFirstGrapheme(last) || pickFirstGrapheme(firstParts[1] ?? ''); // fallback to 2nd token of first name

    const initials = (a + b).toUpperCase();

    return initials || 'U';
  }, [user?.firstName, user?.lastName]);
  const roleName = useMemo(
    () =>
      user?.userType?.displayName || getRoleTypeName(user?.roles[0]?.roleType) || '',
    [user],
  );

  return (
    <div className="flex items-center gap-3">
      <div className="w-8 h-8 bg-gradient-to-b from-[#52FFE5] to-[#69EEFFFA] rounded-full flex justify-center items-center">
        <span className="text-[16px] font-medium text-black">{userChar}</span>
      </div>

      <span className="text-sm font-medium text-gray50 lg:whitespace-nowrap">
        {`${user?.firstName ? `${user?.firstName} ` : ''}${
          user?.lastName ? `${user?.lastName} ` : ''
        } ${roleName ? `(${roleName})` : ''}`}
      </span>
    </div>
  );
}

export default UserInfo;
